(function ($, global) {
  /**
   * Результат выбора из справочника.
   * @typedef {Object} ReferenceSelectData
   * @property {string} id ИД записи.
   * @property {string} encodedTitle Экранированный заголовок записи.
   * @property {string} title Заголовок записи.
   * @property {string} leadingRequisitesValue Значения ведущих реквизитов (в JSON-формате)
   * @since 5.5.0.1000
   */

  /**
   * Функция, вызываемая при удачном выполнении запроса от сервера. 
   * @callback ReferenceSelectSuccessCallback
   * @param {number} pageCount Общее количество страниц с данными.
   * @param {ReferenceSelectData[]} entities Данные от сервера.
   * @since 5.5.0.1000
   */

  /**
   * Функция, вызываемая при НЕ удачном выполнении запроса от сервера. 
   * @callback ReferenceSelectErrorCallback
   * @param {string} message Сообщение об ошибке.
   * @param {boolean} isHttp Признак обозначающий была ли это HTTP ошибка.
   * @since 5.5.0.1000
   */

  /**
   * Провайдер данных для выбора из справочника.
   * @since 5.5.0.1000
   */
  var ReferenceSelectDataProvider = {
    /**
     * Отправляет запрос на сервер и обрабатывает результаты.
     * @param {string} url Адрес веб-сервиса или веб-хэндлера.
     * @param {Object} params Список параметров веб-сервиса или веб-хэндлера.
     * @param {ReferenceSelectSuccessCallback} OnSuccess Функция, вызываемая при удачном выполнении запроса от сервера. 
     * @param {ReferenceSelectErrorCallback} OnError Функция, вызываемая при НЕ удачном выполнении запроса от сервера. 
     * @returns {jqXHR} Объект запроса возвращаемой функцией jQuery.ajax.
     */
    sendQuery: function (url, params, OnSuccess, OnError) {
      var me = this;

      return $.ajax({
        type: "POST",
        dataType: "text",
        url: url,
        cache: false,
        data: params,
        success: function (res) {
          if (!CheckForLoginPage(res)) {
            var data = me._parseResponse(res);
            if (data.success) {
              if (OnSuccess) OnSuccess(data.pagesCount, data.entities);
            } else {
              if (OnError) OnError(data.errorMessage, false);
            }
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if (OnError) OnError(textStatus, true);
        }
      });

    },

    /**
     * Парсит результат от хэндлера в массив объектов.
     * @private
     */
    _parseResponse: function (response) {
      var firstN = response.indexOf('\n');
      var status = response.substr(0, firstN);
      var data = response.substr(firstN + 1);

      if ($.trim(status) != "ERROR") {
        var rows = data.split("\r\n");
        var entities = rows.map(function (row) {
          row = $.trim(row);
          if (row) {
            var currRowData = row.split("|");
            return {
              id: currRowData[0], //строка, т.к. может быть "ПОЛ_103576" таким значением - такое есть в последних используемых объектах
              encodedTitle: currRowData[1].replace("#PIPE#","|"),
              title: currRowData[2].replace("#PIPE#", "|"),
              leadingRequisitesValue: currRowData[3]
            };
          } else {
            return null;
          }
        }).filter(function (entity) { return !!entity; });

        return {
          success: true,
          pagesCount: parseInt(status, 10),
          entities: entities
        };
      } else {
        return {
          success: false,
          errorMessage: data
        };
      }
    }

  };

  global.ReferenceSelectDataProvider = ReferenceSelectDataProvider;

})(jQuery, window);
